import React, { useEffect, useState } from "react";
import ActiveBrokers from "./ActiveBrokers";
import BrokerApiTiles from "./BrokerApiTiles";
import WebhookURLs from "./WebhookURLs";
import { Typography, Stack, Divider, Box } from "@mui/material";
import axios from "axios";
import {WebSocketStatus} from "./WebSocketStatus";

const UserProfile = ({ user, wsStatus }) => {
    const [connectors, setConnectors] = useState([]);
    const [loading, setLoading] = useState(true);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


    const fetchConnectors = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${API_BASE_URL}/user-connector/list`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setConnectors(res.data?.data || res.data);
        } catch (err) {
            console.error("Failed to load user connectors", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchConnectors();
    }, []);

    return (
        <>
            <Typography variant="h5" component="h1" gutterBottom>
                Welcome, {user.full_name} ... <WebSocketStatus status={wsStatus} />
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Box mt={4}>
                <ActiveBrokers onConnectorAdded={fetchConnectors} />
            </Box>
            <Divider sx={{ my: 2 }} />
            <Box mt={4}>
                <BrokerApiTiles connectors={connectors} onRefresh={fetchConnectors} />
            </Box>
            <Divider sx={{ my: 2 }} />
            <Box mt={1}>
                <WebhookURLs />
            </Box>

        </>
    );
};

export default UserProfile;
